import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { FormGroup } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-auto-sync',
    templateUrl: './auto-sync.component.html',
    styleUrls: ['./auto-sync.component.scss'],
    imports: [NgClass]
})
export class AutoSyncComponent implements OnInit {
  public FormControlName;
  config: FieldConfig;
  group: FormGroup;
  @Output() clickSync: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    this.FormControlName = this.config.name;
  }


}

